import { useMutation } from '@tanstack/react-query'
import { postRequest } from 'utils/api/apiRequest'

type Data = {
  code_challenge: string
}

export const usePostEmailVerification = () => {
  return useMutation({
    mutationFn: (data: Data) => postRequest(`/2fa/email-verification`, data),
  })
}
